<div class="bg-white card">
    <div class="custom-grid-card-center">
        <div class="property-type-icons">
            <div *ngFor="let type of segments" class="property-icon" (click)="onSegmentSelect(type.segmentId)"
                 [ngClass]="{'selected-segment': selectedSegmentId === type.segmentId}">
                <img [src]="type.fileUrl" alt="{{ type.segmentLabel }}" class="icon-image">
                <p>{{ type.segmentLabel }}</p>
            </div>
        </div>
        <div class="departments">
            <p-dropdown [options]="departments"
                        [(ngModel)]="selectedDepartment"
                        optionLabel="optionName"
                        optionValue="optionCode"
                        placeholder="Seleccione el departamento"
                        (onChange)="onDepartmentSelect($event)"></p-dropdown>
            <p-dropdown [options]="city"
                        [(ngModel)]="selectedCity"
                        [disabled]="!selectedDepartment"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Seleccione la ciudad"
                        (onChange)="onCityChange($event)"></p-dropdown>
        </div>
        <div class="custom-grid-card-end">
            <button pButton pRipple type="button" class="toggle-filters-btn" (click)="toggleFilters()">
                <span class="px-2">{{ showFilters ? 'Eliminar filtros' : 'Filtros' }}</span>
            </button>
        </div>
    </div>
    <div class="custom-grid-card-start">
        <div class="action-buttons">
            <button *ngFor="let action of offers" pButton type="button" [label]="action.adLabel"
                    [style]="{'background-color': action.color}" class="action-button"
                    (click)="selectOffer(action.adId)"
                    [ngClass]="{'selected-button': selectedOfferId === action.adId}"></button>
        </div>
    </div>
</div>
